import UiChannelTree from "./UiChannelTree";

export default class UiChannels {
  
  private _uiChannelTree: UiChannelTree;
  private _activeChannelId: number | undefined;

  
  constructor(uiChannelTree: UiChannelTree, activeChannelId?: number) {
    this._uiChannelTree = uiChannelTree;
    this._activeChannelId = activeChannelId;
  }

  public get activeChannelId() {
    return this._activeChannelId;
  }
  public set activeChannelId(value) {
    this._activeChannelId = value;
  }
  public get uiChannelTree(): UiChannelTree {
    return this._uiChannelTree;
  }
  public set uiChannelTree(value: UiChannelTree) {
    this._uiChannelTree = value;
  }
  
}